import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
// import FullScreenCommand from './fullScreenCommand'
export default class FullScreenEditing extends Plugin {
	static get pluginName() {
		return 'FullScreenEditing';
	}

	init() {
		// this.editor.commands.add('fullEditor', new Fi)
	}
}
